<template lang="pug">
  validation-observer(ref='observer')
    modal-assinatura(
      v-if="modal"
      titulo="Assinar Ofício de Certidão Negativa"
      texto="Para realizar a assinatura do ofício de certidão negativa é necessário informar a senha do seu certificado digital. Ao finalizar, o documento será assinado."
      @closeModal="closeModal()"
      @callbackSucesso="callbackModalAssinatura"
    )
    div.container-cadastro
      div#passos
        el-steps(:active="passoAtivo" finish-status="success" simple)
          el-step(title="Informar dados")
          el-step(title="Confirmar dados")
      div#corpo
        informar-dados(
          v-if="passoAtivo === 0"
          :processo="processo"
          @atualizarListaCartorios="atualizarListaCartorios"
          @atualizarAnexos="atualizarAnexos"
          @changeInteiroTeor="changeInteiroTeor"
          @exitInformarDados="exitInformarDados"
        )
        confirmar-dados(
          v-if="passoAtivo === 1",
          :oficios="oficios",
          @getBytesPdf="getBytesPdf"
          v-on="$listeners"
        )

    app-buttons-cadastro(
      :isPrimeiroPasso="false",
      :isUltimoPasso="ultimoPasso",
      :showButtonSalvar="false",
      :showButtonDownload="ultimoPasso",
      :showButtonCancelar="false",
      :showButtonProximo="!ultimoPasso",
      @proximo="proximo",
      @salvar="salvar",
      @voltar="voltar",
      @finalizar="finalizar",
      @download="download"
    )
</template>

<script>
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import InformarDados from '@/screens/arrecadacao/cpat/components/oficio/InformarDados'
import ConfirmarDados from '@/screens/arrecadacao/cpat/components/oficio/ConfirmarDados'
import FileHelper from '@/utils/fileHelper'
import ModalAssinatura from '@/components/ModalAssinatura'
import { mapActions } from 'vuex'

const CERTIDAO_NEGATIVA_ARRECADACAO = 'CERTIDAO_NEGATIVA_ARRECADACAO'

export default {
  components: {
    AppButtonsCadastro,
    InformarDados,
    ConfirmarDados,
    ModalAssinatura
  },
  mixins: [AppNotificacao],

  props: {
    oficios: {
      required: true,
      type: Array
    },
    processo: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      guiaAtiva: 'emissao',
      passoAtivo: 0,
      bytes: null,
      modal: false,
      cartoriosSelecionados: [],
      anexos: [],
      inteiroTeor: false
    }
  },

  computed: {
    ultimoPasso () {
      return this.passoAtivo === 1
    }
  },

  methods: {
    ...mapActions({
      salvarOficioCertidaoNegativa: 'oficioArrecadacao/saveCertidaoNegativa',
      finalizarOficio: 'oficioArrecadacao/finalizar',
      assinarCertidaoNegativa: 'oficioArrecadacao/assinarCertidaoNegativa',
      tramitarCertidaoNegativa: 'oficioArrecadacao/tramitarEmissaoMinutas',
      deleteById: 'oficioArrecadacao/deleteById',
      deleteAllCertidoesNaoAssinadas:
        'oficioArrecadacao/deleteAllCertidoesNaoAssinadas'
    }),

    getBytesPdf (bytes) {
      this.bytes = bytes
    },

    atualizarListaCartorios (cartorios) {
      this.cartoriosSelecionados = cartorios
    },

    async salvar () {
      try {
        const oficioBackEnd = { processo: {id: this.processo.id}, anexos: this.anexos }
        const oficios = await this.salvarOficioCertidaoNegativa({
          oficio: oficioBackEnd,
          cartorios: this.cartoriosSelecionados
        })

        this.$emit('atualizarOficios', oficios)

        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.DADOS_SALVOS_SUCESSO
        )
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )

        throw error
      }
    },

    async proximo () {
      const valido = await this.validarCampos()

      if (valido) {
        this.salvar().then(() => {
          this.passoAtivo = this.passoAtivo + 1
        })
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
      }
    },

    goToListagem () {
      this.$router.push({
        name: 'cpat/home',
        query: {
          numeroProcesso: this.processo.numeroProcesso,
          idProcesso: this.processo.id
        }
      })
    },

    goToOficios () {
      this.$router.push({
        name: 'cpat/oficios',
        query: {
          numeroProcesso: this.processo.numeroProcesso,
          idProcesso: this.processo.id
        }
      })
    },

    async finalizar () {
      try {
        await this.tramitarCertidaoNegativa(this.processo.id)
        this.closeModal()
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.CERTIDAO_NEGATIVA_EMITIDA_COM_SUCESSO
        )
        this.goToListagem()
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )
      }
    },

    download () {
      const nome = 'oficio_certidao_negativa.pdf'
      FileHelper.saveFile(this.bytes, nome)
    },

    voltar () {
      if (this.passoAtivo === 1) {
        this.deleteAllCertidoesNaoAssinadas(this.oficios[0].processo.id)
        this.passoAtivo = this.passoAtivo - 1
      } else {
        this.confirmBox(
          'Você tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.',
          this.$messages.TITULO_WARNING,
          () => {
            if (this.$route.query.botaoEmitirOficio) {
              this.goToOficios()
            } else {
              this.goToListagem()
            }
          },
          () => {},
          'Sim',
          'Não'
        )
      }
    },

    validarCampos () {
      if (this.inteiroTeor && this.anexos.length === 0) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Certidão de Inteiro Teor precisa de ao menos um anexo'
        )
        return false
      }
      return this.$refs.observer.validate()
    },

    closeModal () {
      this.modal = false
    },

    callbackModalAssinatura (senha) {
      this.assinarCertidaoNegativa({
        idOficios: this.oficios.map(oficio => oficio.id),
        senha,
        tipoDocumentoAutenticavel: CERTIDAO_NEGATIVA_ARRECADACAO
      })
        .then(async res => {
          if (!this.$route.query.botaoEmitirOficio) {
            await this.tramitarCertidaoNegativa(this.processo.id)
          }
          this.closeModal()
          this.finalizar()
        })
        .catch(err => {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            err.message
          )
        })
    },

    atualizarAnexos (anexos) {
      this.anexos = anexos
    },

    changeInteiroTeor (inteiroTeor) {
      this.inteiroTeor = inteiroTeor
    },

    exitInformarDados () {
      if (this.passoAtivo === 0) {
        this.deleteAllCertidoesNaoAssinadas(this.oficios[0].processo.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .el-step.is-simple .el-step__title {
  font-size: 14px;
}

>>> .el-steps--simple {
  padding: 10px;
}

>>> .el-step.is-simple .el-step__icon {
  width: 12px;
  height: 12px;
}

.container-cadastro {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/components/oficio/EmissaoOficio.vue